import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';

export default function About() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '狠狠撸',
    url: 'https://henhenlu.com/',
    description: '狠狠撸 - 海量资源一站式极速搜索平台',
    email: 'contact@henhenlu.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '海淀区',
      streetAddress: '中关村科技园',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@henhenlu.com',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
      hoursAvailable: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
    },
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于狠狠撸 - 海量资源一站式极速搜索平台',
    description: '了解狠狠撸的品牌故事、平台优势、信誉保障和联系方式',
    url: 'https://henhenlu.com/about',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://henhenlu.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  return (
    <>
      <SchemaOrg data={orgSchema} />
      <SchemaOrg data={aboutSchema} />
      <SchemaOrg data={breadcrumbSchema} />

      <Breadcrumb items={breadcrumbItems} />

      <main className="w-full max-w-7xl mx-auto px-4 md:px-6 py-8">
        <section className="mb-16">
          <div className="text-center mb-12">
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-4">
              关于狠狠撸
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              狠狠撸致力于打造国内领先的海量资源聚合搜索平台，让每一位用户都能享受到极速检索、精准匹配、高效获取的流畅体验
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-4">品牌故事</h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                狠狠撸诞生于2023年，由一群热爱互联网和资源共享的技术极客创立。我们深知在海量信息中找到真正有价值的资源有多难——搜索引擎结果杂乱、资源网站良莠不齐、分类混乱难以定位。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                于是，狠狠撸应运而生。我们专注于<strong>资源聚合与精准检索</strong>，通过智能算法和人工精选相结合的方式，为用户呈现最优质、最相关的内容资源。从学习教育到影视娱乐，从软件工具到设计素材，八大分类覆盖您工作生活的方方面面。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们的使命是<strong>让每一次搜索都有价值</strong>，让资源获取变得简单高效。狠狠撸，狠狠搜，狠狠好用！
              </p>
            </div>
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimal%20tech%20office%20interior%20with%20collaborative%20workspace%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20team%20brainstorming%20around%20large%20screen%2C%20creative%20atmosphere%2C%20professional%20startup%20environment%2C%20natural%20light%20from%20large%20windows&width=800&height=500&seq=about-brand-story&orientation=landscape"
                alt="狠狠撸团队"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </section>

        <section className="mb-16 py-14 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6 rounded-2xl">
          <h2 className="text-xl font-bold text-foreground-950 font-heading mb-10 text-center">
            平台优势
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-flashlight-line', title: '极速检索', desc: '毫秒级搜索响应，智能排序算法，帮您快速定位目标资源' },
              { icon: 'ri-focus-3-line', title: '精准匹配', desc: '基于语义理解的智能匹配引擎，搜索结果高度相关' },
              { icon: 'ri-stack-line', title: '海量资源', desc: '八大分类覆盖，每日500+资源更新，总资源量超18,000条' },
              { icon: 'ri-shield-check-line', title: '安全可靠', desc: '所有资源经过人工审核，确保内容安全、链接有效' },
            ].map((item) => (
              <div key={item.title} className="text-center p-6">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-accent-50 text-accent-600 rounded-xl">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-16">
          <h2 className="text-xl font-bold text-foreground-950 font-heading mb-10 text-center">
            平台信誉
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { value: '120万+', label: '累计服务用户', icon: 'ri-user-heart-line' },
              { value: '99.7%', label: '资源可用率', icon: 'ri-check-double-line' },
              { value: '18,562+', label: '收录资源总量', icon: 'ri-database-2-line' },
              { value: '4.9/5', label: '用户满意度评分', icon: 'ri-star-line' },
            ].map((item) => (
              <div
                key={item.label}
                className="p-6 bg-background-50 rounded-xl border border-background-200/70 text-center"
              >
                <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center bg-primary-50 text-primary-600 rounded-xl">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="text-2xl font-bold text-foreground-950 font-heading mb-1">{item.value}</div>
                <div className="text-sm text-foreground-500">{item.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-6">联系我们</h2>
              <div className="flex flex-col gap-4">
                <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/70">
                  <div className="w-9 h-9 flex items-center justify-center bg-accent-50 text-accent-600 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-800 mb-0.5">电子邮箱</div>
                    <a href="mailto:contact@henhenlu.com" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                      contact@henhenlu.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/70">
                  <div className="w-9 h-9 flex items-center justify-center bg-accent-50 text-accent-600 rounded-lg flex-shrink-0">
                    <i className="ri-customer-service-line"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-800 mb-0.5">在线客服</div>
                    <div className="text-sm text-foreground-500">工作日 9:00 - 18:00（北京时间）</div>
                  </div>
                </div>
                <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl border border-background-200/70">
                  <div className="w-9 h-9 flex items-center justify-center bg-accent-50 text-accent-600 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-800 mb-0.5">公司地址</div>
                    <div className="text-sm text-foreground-500">北京市海淀区中关村科技园创新大厦B座12层</div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-6">快速导航</h2>
              <div className="grid grid-cols-2 gap-3">
                {categories.map((cat) => (
                  <a
                    key={cat.slug}
                    href={`/category/${cat.slug}`}
                    className="flex items-center gap-2.5 p-3 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-secondary-50 text-secondary-600 rounded-lg flex-shrink-0">
                      <i className={`${cat.icon} text-sm`}></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">{cat.name}</div>
                      <div className="text-xs text-foreground-400">{cat.articleCount.toLocaleString()} 条资源</div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}